import { ProblemDetailsFetchError } from "shared-ts-utils-fetch";
import { TFunction } from "i18next";

export const resolvePasswordErrorMessages = (
  e: ProblemDetailsFetchError,
  t: TFunction<"shared-ts-ui-identity">
): string[] => {
  const errorMessages: string[] = [];
  if (e.problemDetails.detail?.includes("DuplicateUserName")) {
    errorMessages.push(t("A user with this username is already registered"));
  } else if (e.problemDetails.type === "IdentityErrorException") {
    if (e.problemDetails.detail?.includes("PasswordRequiresNonAlphanumeric")) {
      errorMessages.push(t("IdentityError.PasswordRequiresNonAlphanumeric"));
    }
    if (e.problemDetails.detail?.includes("PasswordTooShort")) {
      errorMessages.push(t("IdentityError.PasswordTooShort"));
    }
    if (e.problemDetails.detail?.includes("PasswordRequiresDigit")) {
      errorMessages.push(t("IdentityError.PasswordRequiresDigit"));
    }
    if (e.problemDetails.detail?.includes("PasswordRequiresUpper")) {
      errorMessages.push(t("IdentityError.PasswordRequiresUpper"));
    }
  }
  return errorMessages;
};
